import throttle from 'lodash.throttle'
const SCROLL_ARROW = '.scroll-arrow'

const scrollHelper = {
  scrollArrowTimeout: null,
  wrapperEl: null,
  scrollArrowEl: null,
  idleTimeout: null,
  init () {
    window.addEventListener('scroll', throttle(() => {
      this.hideArrow()
    }, 200))
    this.scrollArrowEl = document.querySelector(SCROLL_ARROW)
    this.scrollArrowEl.addEventListener('click', () => {
      this.scrollToBottom()
    })
  },
  scrollToTop () {
    window.scrollTo(0, 0)
  },
  scrollToBottom () {
    window.scrollTo(0, document.body.scrollHeight)
    this.hideArrow()
  },
  showArrow () {
    if ((document.body.clientHeight - window.innerHeight) > 25) {
      this.scrollArrowTimeout = setTimeout(() => {
        this.scrollArrowEl.style.visibility = 'visible'
        this.scrollArrowEl.style.opacity = 1
        this.detectIdle()
        this.initBlinkArrow()
      }, 1000)
    }
  },
  hideArrow () {
    this.scrollArrowEl.style.opacity = 0
    setTimeout(() => {
      this.scrollArrowEl.style.visibility = 'hidden'
    }, 300)
    clearTimeout(this.scrollArrowTimeout)
    clearTimeout(this.idleTimeout)
    if (this.scrollArrowEl) {
      this.scrollArrowEl.classList.remove('blink')
    }
  },
  initBlinkArrow () {
    this.idleTimeout = window.setTimeout(() => {
      if (this.scrollArrowEl) {
        this.scrollArrowEl.classList.add('blink')
      }
    }, 5000)
  },
  detectIdle () {
    document.body.addEventListener('click', () => {
      clearTimeout(this.idleTimeout)
      this.initBlinkArrow()
      if (this.scrollArrowEl) {
        this.scrollArrowEl.classList.remove('blink')
      }
    })
  }
}

export default scrollHelper
